import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // WhatsApp number - Replace with actual number
  const whatsappNumber = '558896527079'; // Format: country code + number (no spaces)
  const whatsappMessage = 'Olá Léo. Estou interessado(a) em seus serviços de Análise de Dados.';
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  useEffect(() => {
    // Show button after a slight delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    // Show tooltip after 3 seconds
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
      // Hide tooltip after 5 seconds
      setTimeout(() => setShowTooltip(false), 5000);
    }, 3000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float-button"
        aria-label="Contact us on WhatsApp"
      >
        <MessageCircle size={28} />
      </a>

      {showTooltip && (
        <div className="whatsapp-tooltip">
          <button 
            className="whatsapp-tooltip-close"
            onClick={(e) => {
              e.preventDefault();
              setShowTooltip(false);
            }}
            aria-label="Close tooltip"
          >
            <X size={16} />
          </button>
          <p>Precisa de ajuda? Fale comigo no Whatsapp!</p>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;